import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MatchService {
  tournamentId: string = '1071149';
  constructor(private http: HttpClient) { }

  makeApiRequest(staticUrl: string, request: string = 'GET', payload: any = undefined): Observable<any> {
    const url = 'https://cricheroes.in/api/v1';

    // Set the headers
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('api-key', '7d313d7c02c39e21dc4abee42760c8f3')
      .set('secret_access_key', 'o5LgzLbpIb-e60b-11e7-mSJcQWyxHf-3de7cd8c6cf4')
      .set('udid', '8817480565574762')
      .set('device-type', 'thirdparty-gt20');

    // Make the request
    if (request == 'GET') {
      return this.http.get(url + staticUrl, { headers });
    } else if (request == 'POST' && payload) {
      return this.http.post(url + staticUrl, payload, { headers });
    } else {
      // ==============
    }
  }
}
